/**
 * Route for `native-snowflake-direct-connector`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { NativeSnowflakeDirectConnectorPage } from "../features/native-snowflake-direct-connector/NativeSnowflakeDirectConnectorPage";

export const nativeSnowflakeDirectConnectorRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/native-snowflake-direct-connector",
	component: NativeSnowflakeDirectConnectorPage,
});

export default nativeSnowflakeDirectConnectorRoute;
